/* src/app/features/limite-pagamento-ecg-por-terceiros/historico/limite-pagamento-ecg-por-terceiros-historico.component.scss */
.bn-paginacao-container {
  width: 100%;
}
.texto-sem-registro {
  font-style: italic;
  font-size: small;
}
/*# sourceMappingURL=limite-pagamento-ecg-por-terceiros-historico.component.css.map */
